module.exports = __webpack_public_path__ + "img/flux-kontext-2.fcc22f23.webp";